/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SPINNER_TYPE_REGULAR, Spinner } from '@squiz/sds';
import React from 'react';
import { DxpScreen } from '../../Components/DxpScreen/DxpScreen';

/**
 * DXP Console - Empty loading screen wrapped inside the DXP frame.
 */
export const LoadingScreenEmpty = (): JSX.Element => {
  const screenContent = (
    <div className="loading">
      <Spinner type={SPINNER_TYPE_REGULAR} />
    </div>
  );

  return <DxpScreen heading={``}>{screenContent}</DxpScreen>;
};
